import { useQuery } from "@tanstack/react-query";
import type { PeriodSummaryIn } from "@/pages/human-resources/time-management/endpoints/analysis/inout/PeriodSummaryIn.ts";
import type { PeriodSummary } from "@/pages/human-resources/time-management/business/analysis/PeriodSummary.ts";
import {
  periodSummaryQueryKey,
  getPeriodSummary,
} from "@/pages/human-resources/time-management/endpoints/PeriodSummaryEndpoint.ts";

export function useReadPeriodSummary(params: PeriodSummaryIn): {
  summaries: PeriodSummary[];
  isFetching: boolean;
} {
  const { data, isFetching } = useQuery<PeriodSummary[]>({
    queryKey: periodSummaryQueryKey.forSiteAndDateAndModes(params),
    queryFn: async () => getPeriodSummary(params),
  });
  return { summaries: data ?? [], isFetching };
}
